import { render, staticRenderFns } from "./PcCappedCard.vue?vue&type=template&id=46d1b937"
import script from "./PcCappedCard.vue?vue&type=script&lang=js"
export * from "./PcCappedCard.vue?vue&type=script&lang=js"
import style0 from "./PcCappedCard.vue?vue&type=style&index=0&id=46d1b937&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCardText,VIcon,VToolbar,VToolbarTitle})
